module.exports = __webpack_public_path__ + "static/fipcgreystar3-078f826b209e0a80a2480dcd73c8c154.jpeg";